export const adminTranslations = {
  fr: {
    title: 'Administration',
    subtitle: 'Tableau de bord administrateur',
    accessDenied: 'Accès refusé',
    restrictedAccess: 'Accès restreint',
    restrictedMessage: 'Vous devez être administrateur pour accéder à cette page.',
    loading: 'Chargement des données...',
    refresh: 'Actualiser',
    checkingPermissions: 'Vérification des autorisations...',
    sidebar: {
      dashboard: 'Dashboard',
      engagement: 'Engagement',
      stats: 'Statistiques',
      aiPrompts: 'Prompts IA',
      mailing: 'Mailing',
      users: 'Utilisateurs',
      xpBadges: 'XP & Badges',
      createChallenge: 'Créer Challenge',
      systemLogs: 'Logs Système',
      expiredCleanup: 'Nettoyage Expirés'
    },
    pushTest: {
      title: 'Test de notifications push web',
      description: 'Envoyez une notification de test à tous les utilisateurs avec des tokens actifs',
      fillTitleMessage: 'Veuillez renseigner un titre et un message',
      sent: '✅ Notification envoyée',
      sentCount: '{{count}} notification(s) envoyée(s) avec succès',
      sendError: "Impossible d'envoyer la notification"
    },
    stats: {
      totalUsers: 'Utilisateurs totaux',
      newThisMonth: '{{count}} nouveaux ce mois',
      paidUsers: 'Utilisateurs payants',
      percentOfTotal: '{{percent}}% du total',
      roi: 'ROI mensuel',
      revenueMinusCosts: 'Revenus - Coûts',
      trials: 'Essais gratuits',
      expired: '{{count}} expirés'
    },
    tabs: {
      users: 'Utilisateurs',
      api: 'API',
      revenue: 'Revenus'
    },
    api: {
      callsLast30Days: 'Appels API (30j)',
      averagePerDay: '{{count}} par jour en moyenne',
      totalCost30Days: 'Coût Total (30j)',
      perDay: '€{{amount}} par jour',
      averageCostPerCall: 'Coût Moyen/Appel',
      averageUnitPrice: 'Prix unitaire moyen',
      recentActivity: 'Activité API Récente',
      last10Calls: 'Les 10 derniers appels API',
      tokens: '{{count}} tokens'
    },
    revenue: {
      breakdown: 'Répartition des Revenus',
      monthlyRevenueByType: 'Revenu mensuel par type d\'abonnement',
      monthlySubscriptions: 'Abonnements mensuels',
      annualSubscriptions: 'Abonnements annuels',
      monthlyTotal: 'Total mensuel',
      userDistribution: 'Distribution des Utilisateurs',
      distributionByStatus: 'Répartition par statut d\'abonnement',
      paidSubscribers: 'Abonnés payants',
      onTrial: 'En essai',
      premiumFree: 'Premium gratuit',
      expiredTrials: 'Essais expirés'
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Gérez vos templates, campagnes et analyses d\'emailing',
      preview: 'Prévisualiser',
      export: 'Exporter',
      new: 'Nouveau',
      search: 'Rechercher templates, campagnes...',
      all: 'Tous',
      email: 'Email',
      notification: 'Notification',
      stats: {
        emailsSent: 'Emails envoyés',
        thisMonth: 'Ce mois',
        openRate: 'Taux d\'ouverture',
        average: 'Moyenne',
        activeTemplates: 'Templates actifs',
        available: 'Disponibles',
        campaigns: 'Campagnes',
        total: 'Total'
      },
      campaigns: {
        title: 'Campagnes de mailing',
        subtitle: 'Gérez et lancez vos campagnes d\'emailing',
        newCampaign: 'Nouvelle campagne',
        noCampaignsFound: 'Aucune campagne trouvée',
        noMatch: 'Aucune campagne ne correspond à votre recherche',
        getStarted: 'Commencez par créer votre première campagne',
        createCampaign: 'Créer une campagne',
        sent: 'envoyés',
        template: 'Template'
      },
      templates: {
        title: 'Templates d\'emailing',
        subtitle: 'Créez et gérez vos modèles d\'emails',
        newTemplate: 'Nouveau template',
        noTemplatesFound: 'Aucun template trouvé',
        noMatch: 'Aucun template ne correspond à votre recherche',
        getStarted: 'Commencez par créer votre premier template',
        createTemplate: 'Créer un template',
        active: 'Actif',
        inactive: 'Inactif'
      },
      tabs: {
        campaigns: 'Campagnes',
        templates: 'Templates',
        push: 'Push',
        actions: 'Actions',
        analytics: 'Analytics'
      },
      quickActions: {
        title: 'Actions rapides',
        subtitle: 'Outils pour créer et envoyer rapidement'
      },
      analytics: {
        title: 'Analytics de mailing',
        subtitle: 'Analysez les performances de vos campagnes',
        noCampaignsSent: 'Aucune campagne envoyée',
        analysisDescription: 'Les analyses apparaîtront ici une fois que vous aurez créé et envoyé vos premières campagnes d\'emailing.',
        createFirstCampaign: 'Créer ma première campagne',
        campaignPerformance: 'Performance des campagnes',
        noCampaignsSentYet: 'Aucune campagne envoyée pour le moment',
        emailsSent: 'envoyés',
        opened: 'ouverts',
        openRate: 'Taux d\'ouverture'
      },
      toasts: {
        error: 'Erreur',
        cannotLoadData: 'Impossible de charger les données de mailing',
        confirmDeleteTemplate: 'Êtes-vous sûr de vouloir supprimer ce template ?',
        templateDeleted: 'Template supprimé avec succès',
        cannotDeleteTemplate: 'Impossible de supprimer le template',
        confirmDeleteCampaign: 'Êtes-vous sûr de vouloir supprimer cette campagne ?',
        campaignDeleted: 'Campagne supprimée avec succès',
        cannotDeleteCampaign: 'Impossible de supprimer la campagne',
        campaignSent: 'Campagne envoyée !',
        emailsSentSuccess: '{{count}} emails envoyés avec succès',
        sendError: 'Erreur d\'envoi',
        cannotSendCampaign: 'Impossible d\'envoyer la campagne',
        templatesExported: 'Templates exportés avec succès'
      }
    },
    dashboard: {
      securityAnalysis: 'Analyse de sécurité en cours...',
      noIssues: 'Aucun problème détecté dans la base de données',
      issuesDetected: '{{count}} problème(s) détecté(s): {{types}}',
      repairing: 'Réparation en cours...',
      repairComplete: 'Réparation terminée: {{count}} problème(s) corrigé(s)',
      error: 'Erreur: {{message}}',
      unknownError: 'Erreur inconnue',
      trialSyncing: 'Synchronisation des essais expirés...',
      trialSyncComplete: 'Synchronisation terminée: {{count}} correction(s)',
      trialSyncError: 'Erreur lors de la synchronisation: {{message}}',
      database: 'Base de données',
      security: 'Sécurité',
      performance: 'Performance',
      maintenanceActions: 'Actions de maintenance',
      maintenanceDesc: 'Outils de diagnostic et de réparation pour maintenir la stabilité du système',
      auditing: 'Audit en cours...',
      auditAndRepair: 'Audit & Réparation',
      syncExpiredTrials: 'Sync essais expirés',
      auditDesc: 'Détecte et corrige les incohérences dans les données utilisateur',
      syncDesc: 'Force la synchronisation des statuts d\'essai expirés',
      recentActivity: 'Activité récente',
      lastCheck: 'Dernière vérification',
      securityAlerts: 'Alertes sécurité',
      criticalAlerts: 'Alertes critiques',
      optimizationSuggested: 'Optimisation suggérée',
      issuesDetectedTitle: '{{count}} problème(s) détecté(s)',
      confirmRepair: 'Voulez-vous lancer la réparation automatique ?',
      cancel: 'Annuler',
      repair: 'Réparer'
    },
    engagement: {
      activeUsers7d: 'Utilisateurs actifs (7j)',
      activeUsers30d: 'Utilisateurs actifs (30j)',
      retention30d: 'Rétention sur 30 jours',
      completedProfiles: 'Profils complétés',
      incompleteProfiles: '{{count}} profils incomplets',
      churnRisk: 'Risque de churn',
      alreadyChurned: '{{count}} déjà churned (30j+)',
      ofTotalUsers: 'Sur {{count}} utilisateurs',
      churnWarning: '⚠️ {{count}} utilisateurs à risque de churn (14-30j inactifs)',
      engagementByFeature: 'Engagement par fonctionnalité (7 jours)',
      interactionsPerFeature: 'Nombre d\'interactions par feature',
      quizCompleted: 'Quiz complétés',
      flashcardReviews: 'Révisions flashcards',
      aiChatMessages: 'Messages chat IA',
      forumPosts: 'Posts forum',
      gamification: 'Gamification',
      badgesAndRewards: 'Badges et récompenses',
      badgesAwarded: 'Badges attribués',
      usersWithBadges: 'Utilisateurs avec badges',
      ofUsers: '{{percent}}% des utilisateurs'
    },
    filters: {
      searchPlaceholder: 'Rechercher par nom ou email...',
      activeFilters: 'Filtres actifs:',
      filter: '{{count}} filtre(s)',
      clearFilters: 'Effacer tous les filtres',
      clearLabel: 'Effacer les filtres',
      all: 'Tous',
      allFeminine: 'Toutes',
      subscriptionStatus: 'Statut abonnement',
      subscribed: 'Abonnés payants',
      trial: 'En essai',
      free: 'Gratuits',
      role: 'Rôle',
      admin: 'Admin',
      moderator: 'Modérateur',
      user: 'Utilisateur',
      trialStatus: 'Statut essai',
      activeTrial: 'Essai actif',
      expiredTrial: 'Essai expiré',
      noTrial: 'Sans essai',
      period: 'Période',
      today: "Aujourd'hui",
      thisWeek: 'Cette semaine',
      thisMonth: 'Ce mois',
      thisQuarter: 'Ce trimestre',
      exportCsv: 'Exporter CSV',
      usersCount: '{{filtered}} / {{total}} utilisateurs',
    },
    prompts: {
      loadError: 'Erreur lors du chargement des prompts',
      savedTranslated: 'Prompt sauvegardé et {{count}} traduction(s) générée(s) automatiquement',
      savedNoTranslation: 'Prompt sauvegardé mais aucune traduction générée',
      savedTranslationFailed: 'Prompt sauvegardé mais traduction automatique échouée',
      savedSuccess: 'Prompt sauvegardé avec succès',
      saveError: 'Erreur lors de la sauvegarde: {{message}}',
      searchPlaceholder: 'Rechercher des prompts...',
      status: 'Statut',
      all: 'Tous',
      active: 'Actif',
      draft: 'Brouillon',
      archived: 'Archivé',
      newPrompt: 'Nouveau Prompt',
      createTitle: 'Créer un nouveau prompt',
      createDesc: 'Créez un nouveau template de prompt IA pour l\'application.',
      editTitle: 'Modifier le prompt',
      editDesc: 'Modifiez les détails de ce template de prompt IA.',
      titleLabel: 'Titre',
      useCase: 'Cas d\'usage',
      selectUseCase: 'Sélectionner un cas d\'usage',
      statusLabel: 'Statut',
      content: 'Contenu',
      contentPlaceholder: 'Écrivez votre prompt ici...',
      tags: 'Tags',
      cancel: 'Annuler',
      create: 'Créer',
      save: 'Sauvegarder',
      tableTitle: 'Titre',
      tableUseCase: 'Cas d\'usage',
      tableStatus: 'Statut',
      tableTags: 'Tags',
      tableUpdated: 'Mis à jour',
      loading: 'Chargement des prompts...',
      noPrompts: 'Aucun prompt trouvé',
      edit: 'Modifier',
      archive: 'Archiver',
      delete: 'Supprimer',
      confirmDelete: 'Confirmer la suppression',
      confirmDeleteDesc: 'Êtes-vous sûr de vouloir supprimer ce prompt ? Cette action est irréversible.'
    },
    promptEditor: {
      title: 'Gestion des Prompts IA',
      description: 'Éditez les prompts système utilisés par l\'IA pour chaque cas d\'usage. Ces prompts définissent le comportement et les compétences de l\'assistant.',
      promptType: 'Type de prompt',
      language: 'Langue',
      contentLabel: 'Contenu du prompt',
      adminOnly: 'Admin seulement',
      contentPlaceholder: 'Entrez le prompt système ici...',
      contextHint: 'Utilisez ${context} comme placeholder pour les informations du profil utilisateur.',
      advancedOptions: 'Options avancées',
      webSearch: 'Recherche sur internet',
      webSearchDesc: 'Permet à l\'IA d\'effectuer des recherches web pour compléter ses réponses',
      temperature: 'Température',
      precise: 'Précise (0.0)',
      creative: 'Créative (1.0)',
      userContextPreview: 'Aperçu du contexte utilisateur',
      userLabel: 'Utilisateur',
      modeLabel: 'Mode',
      serviceLabel: 'Service',
      specialtyLabel: 'Spécialité',
      contextInsertHint: 'Ce contexte sera automatiquement inséré à la place de ${context} dans le prompt.',
      lastModified: 'Dernière modification : Maintenant',
      reset: 'Réinitialiser',
      save: 'Sauvegarder',
      promptsByLanguage: 'Aperçu des prompts par langue :',
      notConfigured: 'Non configuré',
      types: {
        general: 'Général',
        diagnostic: 'Diagnostic',
        priseEnCharge: 'Prise en charge',
        formation: 'Formation',
        these: 'Thèse',
        pmsi: 'PMSI',
        rsca: 'RSCA',
        analysePrescriptions: 'Analyse de Prescriptions',
        casComplexes: 'Cas complexes',
        triage: 'Triage',
        diagnosisCoding: 'Codage diagnostique',
        prescriptionAnalysis: 'Analyse prescriptions (legacy)',
        patientSummary: 'Résumé patient',
        qcm: 'QCM',
        clinicalCase: 'Cas clinique',
        fiche: 'Fiches de révision',
        imageAnalysis: 'Analyse d\'image',
        medicationAnalysis: 'Analyse médicaments',
        rcpAnalysis: 'Analyse RCP',
        structureConsultation: 'Structuration consultation'
      }
    },
    challenges: {
      createTitle: 'Créer un Challenge',
      createSubtitle: 'Engagez votre communauté avec des défis motivants',
      newChallenge: 'Créer un nouveau challenge',
      newChallengeDesc: 'Créez un challenge hebdomadaire pour engager la communauté',
      challengeTitle: 'Titre du challenge',
      titlePlaceholder: 'Révise 50 flashcards cette semaine',
      description: 'Description',
      descPlaceholder: 'Décrivez le challenge et ses objectifs...',
      challengeType: 'Type de challenge',
      flashcardReview: 'Révision de flashcards',
      quizCompletion: 'Complétion de quiz',
      studyTime: 'Temps d\'étude (minutes)',
      goal: 'Objectif',
      specialty: 'Spécialité (optionnel)',
      specialtyPlaceholder: 'Ex: Cardiologie',
      durationDays: 'Durée (jours)',
      rewardXp: 'Récompense XP',
      badge: 'Badge (optionnel)',
      creating: 'Création...',
      createChallenge: 'Créer le challenge',
      cancel: 'Annuler'
    },
    systemLogs: {
      filtersAndSearch: 'Filtres et recherche',
      search: 'Recherche',
      searchPlaceholder: 'Rechercher dans les logs...',
      period: 'Période',
      lastHour: 'Dernière heure',
      last24h: 'Dernières 24h',
      last7d: '7 derniers jours',
      last30d: '30 derniers jours',
      actionType: 'Type d\'action',
      allActions: 'Toutes les actions',
      security: 'Sécurité',
      errors: 'Erreurs',
      logins: 'Connexions',
      roleChanges: 'Changements de rôle',
      results: 'Résultats',
      events: '{{count}} événements',
      loadingLogs: 'Chargement des logs...',
      securityEvents: 'Événements de sécurité',
      generalActivity: 'Activité générale',
      securityEventsTitle: 'Événements de Sécurité',
      securityEventsDesc: 'Logs de sécurité et violations détectées',
      generalActivityTitle: 'Activité Générale',
      generalActivityDesc: 'Tous les événements système et utilisateur',
      noSecurityEvents: 'Aucun événement de sécurité trouvé',
      goodNews: 'C\'est une bonne nouvelle !',
      securityBadge: 'Sécurité',
      errorBadge: 'Erreur',
      infoBadge: 'Info'
    },
    push: {
      testTitle: 'Test de Notification Push',
      userId: 'ID Utilisateur',
      userIdPlaceholder: 'UUID de l\'utilisateur',
      title: 'Titre',
      titlePlaceholder: 'Titre de la notification',
      message: 'Message',
      messagePlaceholder: 'Contenu de la notification',
      sending: 'Envoi...',
      sendTest: 'Envoyer Test',
      totalTokens: 'Total tokens',
      activeTokens: 'Tokens actifs',
      validWebPush: 'Web Push valides',
      defectiveTokens: 'Tokens défectueux'
    },
    templateEditor: {
      types: {
        system: 'Système',
        community: 'Communauté',
        progression: 'Progression',
        reminder: 'Rappel',
        security: 'Sécurité',
        marketing: 'Marketing',
        reactivation: 'Réactivation',
      }
    },
    templates: {
      editTemplate: 'Modifier le template',
      newTemplate: 'Nouveau template',
      createDesc: 'Créez ou modifiez un template d\'email pour vos campagnes de notifications',
      name: 'Nom du template',
      namePlaceholder: 'Ex: Email de bienvenue',
      type: 'Type',
      channel: 'Canal',
      subject: 'Sujet',
      subjectPlaceholder: 'Sujet de l\'email',
      availableVars: 'Variables disponibles',
      selectedVars: 'Variables sélectionnées',
      htmlContent: 'Contenu HTML',
      pushMessage: 'Message',
      pushPlaceholder: 'Message de la notification push...',
      htmlPlaceholder: 'Contenu HTML de l\'email...',
      textContent: 'Contenu texte (optionnel)',
      textPlaceholder: 'Version texte de l\'email...',
      activeTemplate: 'Template actif',
      cancel: 'Annuler',
      saving: 'Sauvegarde...',
      save: 'Sauvegarder',
      preview: 'Aperçu',
      previewTitle: 'Aperçu du template',
      close: 'Fermer',
      previewTemplates: 'Prévisualisation des Templates',
      previewDesc: 'Prévisualisez et testez vos templates d\'email avec les designs Sclépios',
      selectTemplate: 'Sélectionner un template',
      templateVars: 'Variables du template',
      varPlaceholder: 'Valeur pour {{{{var}}}}',
      testSend: 'Test d\'envoi',
      testEmail: 'Email de test',
      sending: 'Envoi...',
      sendTest: 'Envoyer un test',
      templateInfo: 'Informations du template',
      variables: 'Variables',
      noVars: 'Aucune',
      emailPreview: 'Prévisualisation de l\'email',
      selectForPreview: 'Sélectionnez un template pour la prévisualisation'
    },
    cleanup: {
      timeline: 'Timeline de traitement ({{count}} utilisateurs)',
      searchEmail: 'Rechercher par email...',
      filterByStage: 'Filtrer par étape',
      allStages: 'Toutes les étapes',
      warningSent: 'Avertissement envoyé',
      scheduledDeletion: 'Suppression programmée',
      deleted: 'Supprimé',
      warningShort: 'Averti',
      scheduledShort: 'Programmé',
      email: 'Email',
      currentStage: 'Étape actuelle',
      warningDate: 'Avertissement envoyé',
      deletionDate: 'Suppression programmée',
      showing: 'Affichage de {{from}} à {{to}} sur {{total}} résultats',
      previous: 'Précédent',
      previousShort: 'Préc.',
      next: 'Suivant',
      nextShort: 'Suiv.',
      page: 'Page {{current}} sur {{total}}',
      inactiveUsers: 'Utilisateurs inactifs',
      identifiedInactive: 'Identifiés comme inactifs',
      warningsSent: 'Avertissements envoyés',
      usersWarned: 'Utilisateurs prévenus',
      scheduledDeletions: 'Suppressions programmées',
      deletionIn30Days: 'Suppression dans 30 jours',
      completedDeletions: 'Suppressions réalisées',
      deletedAccounts: 'Comptes supprimés',
      lastExecution: 'Dernière exécution',
      usersScanned: 'utilisateurs scannés',
      emailsSimulated: 'emails simulés',
      emailsSent: 'emails envoyés',
      deletionsSimulated: 'suppressions simulées',
      deletionsReal: 'suppressions réelles',
      success: 'Succès',
      failure: 'Échec',
      noActionApplied: 'Aucune action appliquée',
      testDryRun: 'Test (dry run)'
    },
    xpBadge: {
      syncSuccess: 'Synchronisation réussie',
      syncSuccessDesc: 'XP synchronisés: {{xp}} XP, niveau {{level}}',
      syncGlobalDone: 'Synchronisation globale terminée',
      syncGlobalDesc: '{{users}} utilisateurs synchronisés, {{xp}} XP récupérés',
      syncError: 'Erreur de synchronisation',
      syncGlobalError: 'Erreur de synchronisation globale',
      badgesChecked: 'Badges vérifiés',
      badgesCheckedDesc: 'Attribution des badges manquants terminée',
      badgeError: 'Erreur attribution badges',
      loadError: 'Impossible de charger les statistiques XP.',
      users: 'Utilisateurs',
      toSync: 'À synchroniser',
      noBadges: 'Sans badges',
      totalXP: 'XP total',
      totalUsers: 'Utilisateurs total',
      needsSync: 'Besoin sync XP',
      calculatedXP: 'XP total calculé',
      detailPerUser: 'Détail par utilisateur',
      xpProfile: 'XP Profil',
      xpCalculated: 'XP Calculé',
      sessions: 'Sessions',
      badges: 'Badges',
      status: 'Statut',
      actions: 'Actions',
      desync: 'Désynchronisé',
      syncXP: 'Synchroniser XP',
      awardBadges: 'Attribuer badges',
      syncGlobal: 'Sync Global'
    },
    notifications2: {
      emailsSent: 'Emails envoyés',
      openRate: 'Taux d\'ouverture',
      send: 'Envoyer',
      historyTemplates: 'Historique & Templates',
      sendStats: 'Statistiques d\'envoi',
      resetStuck: 'Réinitialiser bloquées',
      resetting: 'Réinitialisation...',
      noCampaignsStuck: 'Aucune campagne bloquée',
      allCampaignsValid: 'Toutes les campagnes sont valides',
      resetError: 'Erreur lors de la réinitialisation'
    },
    pushManager: {
      title: 'Notifications Push',
      subtitle: 'Envoyez des notifications push directement aux appareils des utilisateurs',
      totalDevices: 'Appareils totaux',
      activeDevices: 'Actifs',
      validWebPush: 'Web Push valides',
      invalidTokens: 'Tokens invalides',
      deliveryRate: 'Taux livraison',
      platformBreakdown: 'Répartition par plateforme',
      userSegmentation: 'Segmentation des utilisateurs',
      trialExpired: 'Essai expiré',
      activeSubscribers: 'Abonnés actifs',
      free: 'Gratuit',
      premium: 'Premium',
      inactive: 'Inactifs',
      sendNotification: 'Envoyer une notification',
      notifTitle: 'Titre',
      notifTitlePlaceholder: 'Titre de la notification',
      notifMessage: 'Message',
      notifMessagePlaceholder: 'Contenu de la notification',
      chars: '{{count}}/{{max}} caractères',
      targetUrl: 'URL de destination (optionnel)',
      targetUrlPlaceholder: 'https://exemple.com/page-destination',
      targetUrlHint: "L'utilisateur sera redirigé vers cette URL en cliquant sur la notification",
      targetAudience: 'Audience cible',
      allUsers: 'Tous les utilisateurs',
      subscribers: 'Abonnés actifs',
      trialExpiredOption: "Période d'essai expirée",
      bySubscriptionTier: "Par tier d'abonnement",
      byRole: 'Par rôle spécifique',
      inactiveUsers: 'Utilisateurs inactifs',
      specificRole: 'Rôle spécifique',
      selectRole: 'Sélectionner un rôle',
      doctors: 'Docteurs',
      nurses: 'Infirmiers',
      residents: 'Résidents',
      users: 'Utilisateurs',
      subscriptionTier: "Tier d'abonnement",
      selectTier: 'Sélectionner un tier',
      basic: 'Basic',
      enterprise: 'Enterprise',
      audiencePreview: "Aperçu de l'audience: {{count}} utilisateur(s) ciblé(s)",
      target: 'Cible',
      undefined: 'Non défini',
      sending: 'Envoi...',
      send: 'Envoyer',
      requiredFields: 'Champs requis',
      fillTitleAndMessage: 'Veuillez remplir le titre et le message',
      notifSent: 'Notification envoyée !',
      notifSentDesc: '{{count}} notifications envoyées avec succès',
      sendError: "Erreur d'envoi",
      sendErrorDesc: "Impossible d'envoyer la notification"
    },
    usageBreakdown: {
      loading: 'Chargement...',
      filtersAndSearch: 'Filtres et recherche',
      search: 'Rechercher',
      functionPlaceholder: 'Nom de fonction...',
      function: 'Fonction',
      allFunctions: 'Toutes les fonctions',
      model: 'Modèle',
      allModels: 'Tous les modèles',
      period: 'Période',
      last7d: '7 derniers jours',
      last30d: '30 derniers jours',
      last90d: '90 derniers jours',
      totalCost: 'Coût total',
      tokensIn: 'Tokens IN',
      tokensOut: 'Tokens OUT',
      avgCostPerRequest: 'Coût moyen/requête',
      totalRequests: 'Requêtes totales',
      displayed: '({{count}} affichées)',
      dailyUsage: 'Utilisation quotidienne',
      topFunctions: 'Fonctions les plus utilisées',
      costEur: 'Coût (€)',
      detailedLogs: 'Logs détaillés ({{count}} résultats)',
      date: 'Date',
      cost: 'Coût'
    },
    emailSender: {
      sendNotification: 'Envoyer une notification',
      createAndSend: 'Créez et envoyez rapidement des emails à vos utilisateurs',
      directEmail: 'Email direct',
      useTemplate: 'Utiliser un template',
      selectTemplate: 'Sélectionner un template',
      chooseTemplate: 'Choisir un template...',
      campaignName: 'Nom de la campagne (optionnel)',
      campaignNamePlaceholder: 'Ex: Annonce nouvelles fonctionnalités',
      targetAudience: 'Audience cible',
      testEmail: 'Email de test',
      testEmailLabel: 'Adresse email de test',
      testEmailPlaceholder: 'test@exemple.com',
      audienceTestEmail: 'Email de test',
      audienceTestEmailDesc: 'Envoyer à une adresse email spécifique pour tester',
      audienceAll: 'Tous les utilisateurs',
      audienceAllDesc: 'Envoyer à tous les utilisateurs actifs',
      audienceTrialExpired: 'Essais expirés',
      audienceTrialExpiredDesc: "Utilisateurs dont l'essai a expiré sans conversion",
      audienceInactive7d: 'Inactifs +7 jours',
      audienceInactive7dDesc: 'Utilisateurs inactifs depuis plus de 7 jours',
      audienceInactive30d: 'Inactifs +30 jours',
      audienceInactive30dDesc: 'Utilisateurs inactifs depuis plus de 30 jours',
      audienceSubscribed: 'Abonnés payants',
      audienceSubscribedDesc: 'Utilisateurs avec un abonnement actif',
      audienceFreeTier: 'Tier gratuit',
      audienceFreeTierDesc: 'Utilisateurs en version gratuite',
      recipients: '{{count}} destinataires',
      sendEstimation: 'Envoi estimé en ~{{days}} jour(s) (limite: {{limit}}/jour)',
      emailSubject: "Sujet de l'email",
      emailSubjectPlaceholder: '🚀 Découvrez les nouveautés de Sclépios !',
      htmlContent: 'Contenu HTML',
      preview: 'Aperçu',
      availableVars: 'Variables disponibles',
      scheduleOptional: "Programmer l'envoi (optionnel)",
      sendingInProgress: 'Envoi en cours...',
      scheduleSend: "Programmer l'envoi",
      sendNow: 'Envoyer maintenant',
      largeWarning: 'Cette campagne sera envoyée progressivement sur {{days}} jour(s) pour respecter la limite de {{limit}} emails/jour.',
      emailPreview: "Aperçu de l'email",
      subject: 'Sujet',
      mustBeLoggedIn: 'Vous devez être connecté',
      fillSubjectAndContent: 'Veuillez remplir le sujet et le contenu',
      subjectNotEmail: "Le sujet ne peut pas être une adresse email",
      invalidTestEmail: 'Veuillez entrer une adresse email valide pour le test',
      campaignSent: 'Campagne envoyée !',
      campaignSentDesc: "{{count}} emails mis en file d'attente. Estimation: ~{{days}} jour(s)",
      campaignScheduled: 'Campagne programmée',
      campaignScheduledDesc: 'Envoi prévu le {{date}}',
      sendCampaignError: "Impossible d'envoyer la campagne"
    },
    campaignHistory: {
      title: 'Historique des campagnes',
      search: 'Rechercher...',
      status: 'Statut',
      all: 'Tous',
      sent: 'Envoyé',
      queued: 'En file',
      sendingStatus: 'Envoi...',
      scheduled: 'Programmé',
      draft: 'Brouillon',
      failed: 'Échec',
      sentFilter: 'Envoyés',
      queuedFilter: 'En file',
      scheduledFilter: 'Programmés',
      draftsFilter: 'Brouillons',
      failedFilter: 'Échecs',
      loading: 'Chargement...',
      noCampaigns: 'Aucune campagne trouvée',
      openings: 'ouvertures',
      deleteCampaignTitle: 'Supprimer la campagne ?',
      deleteCampaignDesc: "Cette action est irréversible. Les emails en file d'attente associés seront également supprimés.",
      cancel: 'Annuler',
      delete: 'Supprimer',
      campaignSent: 'Campagne envoyée !',
      campaignSentDesc: "{{count}} emails mis en file d'attente",
      sendError: "Impossible d'envoyer la campagne",
      campaignDeleted: 'Campagne supprimée',
      deleteError: 'Impossible de supprimer la campagne'
    },
    templateList: {
      emailTemplates: 'Templates email',
      newTemplate: 'Nouveau template',
      searchPlaceholder: 'Rechercher un template...',
      marketing: 'Marketing',
      system: 'Système',
      loading: 'Chargement...',
      noMarketingTemplates: 'Aucun template marketing. Créez-en un !',
      noSystemTemplates: 'Aucun template système trouvé',
      inactive: 'Inactif',
      editTemplate: 'Éditer le template',
      previewAndTest: 'Prévisualiser et envoyer un test',
      deleteTemplate: 'Supprimer le template',
      deleteTitle: 'Supprimer le template ?',
      deleteDesc: 'Cette action est irréversible. Les campagnes utilisant ce template ne pourront plus être envoyées.',
      cancel: 'Annuler',
      delete: 'Supprimer',
      templateDeleted: 'Template supprimé',
      deleteError: 'Impossible de supprimer le template'
    },
    calculator: {
      calculator: 'Calculateur',
      favorites: 'Favoris',
      history: 'Historique',
      searchPlaceholder: 'Rechercher un calcul...',
      category: 'Catégorie',
      allCategories: 'Toutes les catégories',
      noFavorites: 'Aucun calculateur en favori',
      addFavoriteHint: "Cliquez sur l'étoile pour ajouter vos calculateurs préférés",
      calculationHistory: 'Historique des calculs',
      export: 'Exporter',
      noHistory: "Aucun calcul dans l'historique",
      recentCalcsHint: 'Vos calculs récents apparaîtront ici'
    },
    costAlerts: {
      roiCritical: 'ROI Critique',
      roiCriticalMsg: 'Les coûts IA représentent {{percent}}% du revenu mensuel',
      dailyCostHigh: 'Coût Quotidien Élevé',
      dailyCostHighMsg: 'Projection mensuelle: €{{projected}} (coût quotidien: €{{daily}})',
      budgetExceeded: 'Budget Dépassé',
      budgetExceededMsg: 'Coût mensuel actuel: €{{current}} (limite: €{{limit}})',
      testAlertTitle: 'Test Alerte Coût',
      testAlertMsg: "Notification de test du système d'alertes"
    },
    subscriptions: {
      monthly: 'Mensuel',
      annual: 'Annuel',
      trial: 'Essai gratuit',
      premiumFree: 'Premium gratuit',
      expired: 'Expiré',
      free: 'Gratuit'
    }
  },
  en: {
    title: 'Administration',
    subtitle: 'Admin Dashboard',
    accessDenied: 'Access denied',
    restrictedAccess: 'Restricted Access',
    restrictedMessage: 'You must be an administrator to access this page.',
    loading: 'Loading data...',
    refresh: 'Refresh',
    checkingPermissions: 'Checking permissions...',
    sidebar: {
      dashboard: 'Dashboard',
      engagement: 'Engagement',
      stats: 'Statistics',
      aiPrompts: 'AI Prompts',
      mailing: 'Mailing',
      users: 'Users',
      xpBadges: 'XP & Badges',
      createChallenge: 'Create Challenge',
      systemLogs: 'System Logs',
      expiredCleanup: 'Expired Cleanup'
    },
    pushTest: {
      title: 'Web push notification test',
      description: 'Send a test notification to all users with active tokens',
      fillTitleMessage: 'Please fill in the title and message',
      sent: '✅ Notification sent',
      sentCount: '{{count}} notification(s) sent successfully',
      sendError: 'Unable to send the notification'
    },
    stats: {
      totalUsers: 'Total Users',
      newThisMonth: '{{count}} new this month',
      paidUsers: 'Paid Users',
      percentOfTotal: '{{percent}}% of total',
      roi: 'Monthly ROI',
      revenueMinusCosts: 'Revenue - Costs',
      trials: 'Free Trials',
      expired: '{{count}} expired'
    },
    tabs: {
      users: 'Users',
      api: 'API',
      revenue: 'Revenue'
    },
    api: {
      callsLast30Days: 'API Calls (30d)',
      averagePerDay: '{{count}} per day average',
      totalCost30Days: 'Total Cost (30d)',
      perDay: '€{{amount}} per day',
      averageCostPerCall: 'Average Cost/Call',
      averageUnitPrice: 'Average unit price',
      recentActivity: 'Recent API Activity',
      last10Calls: 'Last 10 API calls',
      tokens: '{{count}} tokens'
    },
    revenue: {
      breakdown: 'Revenue Breakdown',
      monthlyRevenueByType: 'Monthly revenue by subscription type',
      monthlySubscriptions: 'Monthly subscriptions',
      annualSubscriptions: 'Annual subscriptions',
      monthlyTotal: 'Monthly total',
      userDistribution: 'User Distribution',
      distributionByStatus: 'Distribution by subscription status',
      paidSubscribers: 'Paid subscribers',
      onTrial: 'On trial',
      premiumFree: 'Premium free',
      expiredTrials: 'Expired trials'
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Manage your templates, campaigns and emailing analytics',
      preview: 'Preview',
      export: 'Export',
      new: 'New',
      search: 'Search templates, campaigns...',
      all: 'All',
      email: 'Email',
      notification: 'Notification',
      stats: {
        emailsSent: 'Emails sent',
        thisMonth: 'This month',
        openRate: 'Open rate',
        average: 'Average',
        activeTemplates: 'Active templates',
        available: 'Available',
        campaigns: 'Campaigns',
        total: 'Total'
      },
      campaigns: {
        title: 'Email campaigns',
        subtitle: 'Manage and launch your email campaigns',
        newCampaign: 'New campaign',
        noCampaignsFound: 'No campaigns found',
        noMatch: 'No campaigns match your search',
        getStarted: 'Start by creating your first campaign',
        createCampaign: 'Create campaign',
        sent: 'sent',
        template: 'Template'
      },
      templates: {
        title: 'Email templates',
        subtitle: 'Create and manage your email templates',
        newTemplate: 'New template',
        noTemplatesFound: 'No templates found',
        noMatch: 'No templates match your search',
        getStarted: 'Start by creating your first template',
        createTemplate: 'Create template',
        active: 'Active',
        inactive: 'Inactive'
      },
      tabs: {
        campaigns: 'Campaigns',
        templates: 'Templates',
        push: 'Push',
        actions: 'Actions',
        analytics: 'Analytics'
      },
      quickActions: {
        title: 'Quick actions',
        subtitle: 'Tools to create and send quickly'
      },
      analytics: {
        title: 'Email analytics',
        subtitle: 'Analyze your campaign performance',
        noCampaignsSent: 'No campaigns sent',
        analysisDescription: 'Analytics will appear here once you have created and sent your first email campaigns.',
        createFirstCampaign: 'Create my first campaign',
        campaignPerformance: 'Campaign performance',
        noCampaignsSentYet: 'No campaigns sent yet',
        emailsSent: 'sent',
        opened: 'opened',
        openRate: 'Open rate'
      },
      toasts: {
        error: 'Error',
        cannotLoadData: 'Unable to load email data',
        confirmDeleteTemplate: 'Are you sure you want to delete this template?',
        templateDeleted: 'Template deleted successfully',
        cannotDeleteTemplate: 'Unable to delete template',
        confirmDeleteCampaign: 'Are you sure you want to delete this campaign?',
        campaignDeleted: 'Campaign deleted successfully',
        cannotDeleteCampaign: 'Unable to delete campaign',
        campaignSent: 'Campaign sent!',
        emailsSentSuccess: '{{count}} emails sent successfully',
        sendError: 'Send error',
        cannotSendCampaign: 'Unable to send campaign',
        templatesExported: 'Templates exported successfully'
      }
    },
    dashboard: {
      securityAnalysis: 'Security analysis in progress...',
      noIssues: 'No issues detected in the database',
      issuesDetected: '{{count}} issue(s) detected: {{types}}',
      repairing: 'Repairing...',
      repairComplete: 'Repair complete: {{count}} issue(s) fixed',
      error: 'Error: {{message}}',
      unknownError: 'Unknown error',
      trialSyncing: 'Syncing expired trials...',
      trialSyncComplete: 'Sync complete: {{count}} correction(s)',
      trialSyncError: 'Sync error: {{message}}',
      database: 'Database',
      security: 'Security',
      performance: 'Performance',
      maintenanceActions: 'Maintenance Actions',
      maintenanceDesc: 'Diagnostic and repair tools to maintain system stability',
      auditing: 'Auditing...',
      auditAndRepair: 'Audit & Repair',
      syncExpiredTrials: 'Sync expired trials',
      auditDesc: 'Detects and fixes inconsistencies in user data',
      syncDesc: 'Forces synchronization of expired trial statuses',
      recentActivity: 'Recent activity',
      lastCheck: 'Last check',
      securityAlerts: 'Security alerts',
      criticalAlerts: 'Critical alerts',
      optimizationSuggested: 'Optimization suggested',
      issuesDetectedTitle: '{{count}} issue(s) detected',
      confirmRepair: 'Do you want to start automatic repair?',
      cancel: 'Cancel',
      repair: 'Repair'
    },
    engagement: {
      activeUsers7d: 'Active users (7d)',
      activeUsers30d: 'Active users (30d)',
      retention30d: '30-day retention',
      completedProfiles: 'Completed profiles',
      incompleteProfiles: '{{count}} incomplete profiles',
      churnRisk: 'Churn risk',
      alreadyChurned: '{{count}} already churned (30d+)',
      ofTotalUsers: 'Of {{count}} users',
      churnWarning: '⚠️ {{count}} users at risk of churn (14-30d inactive)',
      engagementByFeature: 'Engagement by feature (7 days)',
      interactionsPerFeature: 'Number of interactions per feature',
      quizCompleted: 'Quizzes completed',
      flashcardReviews: 'Flashcard reviews',
      aiChatMessages: 'AI chat messages',
      forumPosts: 'Forum posts',
      gamification: 'Gamification',
      badgesAndRewards: 'Badges and rewards',
      badgesAwarded: 'Badges awarded',
      usersWithBadges: 'Users with badges',
      ofUsers: '{{percent}}% of users'
    },
    filters: {
      searchPlaceholder: 'Search by name or email...',
      activeFilters: 'Active filters:',
      filter: '{{count}} filter(s)',
      clearFilters: 'Clear all filters',
      clearLabel: 'Clear filters',
      all: 'All',
      allFeminine: 'All',
      subscriptionStatus: 'Subscription status',
      subscribed: 'Paid subscribers',
      trial: 'On trial',
      free: 'Free',
      role: 'Role',
      admin: 'Admin',
      moderator: 'Moderator',
      user: 'User',
      trialStatus: 'Trial status',
      activeTrial: 'Active trial',
      expiredTrial: 'Expired trial',
      noTrial: 'No trial',
      period: 'Period',
      today: 'Today',
      thisWeek: 'This week',
      thisMonth: 'This month',
      thisQuarter: 'This quarter',
      exportCsv: 'Export CSV',
      usersCount: '{{filtered}} / {{total}} users',
    },
    prompts: {
      loadError: 'Error loading prompts',
      savedTranslated: 'Prompt saved and {{count}} translation(s) generated automatically',
      savedNoTranslation: 'Prompt saved but no translations generated',
      savedTranslationFailed: 'Prompt saved but automatic translation failed',
      savedSuccess: 'Prompt saved successfully',
      saveError: 'Error saving: {{message}}',
      searchPlaceholder: 'Search prompts...',
      status: 'Status',
      all: 'All',
      active: 'Active',
      draft: 'Draft',
      archived: 'Archived',
      newPrompt: 'New Prompt',
      createTitle: 'Create new prompt',
      createDesc: 'Create a new AI prompt template for the application.',
      editTitle: 'Edit prompt',
      editDesc: 'Edit the details of this AI prompt template.',
      titleLabel: 'Title',
      useCase: 'Use case',
      selectUseCase: 'Select a use case',
      statusLabel: 'Status',
      content: 'Content',
      contentPlaceholder: 'Write your prompt here...',
      tags: 'Tags',
      cancel: 'Cancel',
      create: 'Create',
      save: 'Save',
      tableTitle: 'Title',
      tableUseCase: 'Use case',
      tableStatus: 'Status',
      tableTags: 'Tags',
      tableUpdated: 'Updated',
      loading: 'Loading prompts...',
      noPrompts: 'No prompts found',
      edit: 'Edit',
      archive: 'Archive',
      delete: 'Delete',
      confirmDelete: 'Confirm deletion',
      confirmDeleteDesc: 'Are you sure you want to delete this prompt? This action is irreversible.'
    },
    templateEditor: {
      types: {
        system: 'System',
        community: 'Community',
        progression: 'Progression',
        reminder: 'Reminder',
        security: 'Security',
        marketing: 'Marketing',
        reactivation: 'Reactivation',
      }
    },
    templates: {
      editTemplate: 'Edit template',
      newTemplate: 'New template',
      createDesc: 'Create or edit an email template for your notification campaigns',
      name: 'Template name',
      namePlaceholder: 'E.g. Welcome email',
      type: 'Type',
      channel: 'Channel',
      subject: 'Subject',
      subjectPlaceholder: 'Email subject',
      availableVars: 'Available variables',
      selectedVars: 'Selected variables',
      htmlContent: 'HTML content',
      pushMessage: 'Message',
      pushPlaceholder: 'Push notification message...',
      htmlPlaceholder: 'Email HTML content...',
      textContent: 'Text content (optional)',
      textPlaceholder: 'Text version of the email...',
      activeTemplate: 'Active template',
      cancel: 'Cancel',
      saving: 'Saving...',
      save: 'Save',
      preview: 'Preview',
      previewTitle: 'Template preview',
      close: 'Close',
      previewTemplates: 'Template Preview',
      previewDesc: 'Preview and test your email templates with Sclépios designs',
      selectTemplate: 'Select a template',
      templateVars: 'Template variables',
      varPlaceholder: 'Value for {{{{var}}}}',
      testSend: 'Test send',
      testEmail: 'Test email',
      sending: 'Sending...',
      sendTest: 'Send test',
      templateInfo: 'Template information',
      variables: 'Variables',
      noVars: 'None',
      emailPreview: 'Email preview',
      selectForPreview: 'Select a template for preview'
    },
    cleanup: {
      timeline: 'Processing timeline ({{count}} users)',
      searchEmail: 'Search by email...',
      filterByStage: 'Filter by stage',
      allStages: 'All stages',
      warningSent: 'Warning sent',
      scheduledDeletion: 'Scheduled deletion',
      deleted: 'Deleted',
      warningShort: 'Warned',
      scheduledShort: 'Scheduled',
      email: 'Email',
      currentStage: 'Current stage',
      warningDate: 'Warning sent',
      deletionDate: 'Scheduled deletion',
      showing: 'Showing {{from}} to {{to}} of {{total}} results',
      previous: 'Previous',
      previousShort: 'Prev.',
      next: 'Next',
      nextShort: 'Next',
      page: 'Page {{current}} of {{total}}',
      inactiveUsers: 'Inactive users',
      identifiedInactive: 'Identified as inactive',
      warningsSent: 'Warnings sent',
      usersWarned: 'Users warned',
      scheduledDeletions: 'Scheduled deletions',
      deletionIn30Days: 'Deletion in 30 days',
      completedDeletions: 'Completed deletions',
      deletedAccounts: 'Deleted accounts',
      lastExecution: 'Last execution',
      usersScanned: 'users scanned',
      emailsSimulated: 'emails simulated',
      emailsSent: 'emails sent',
      deletionsSimulated: 'deletions simulated',
      deletionsReal: 'real deletions',
      success: 'Success',
      failure: 'Failure',
      noActionApplied: 'No action applied',
      testDryRun: 'Test (dry run)'
    },
    xpBadge: {
      syncSuccess: 'Sync successful',
      syncSuccessDesc: 'XP synced: {{xp}} XP, level {{level}}',
      syncGlobalDone: 'Global sync completed',
      syncGlobalDesc: '{{users}} users synced, {{xp}} XP recovered',
      syncError: 'Sync error',
      syncGlobalError: 'Global sync error',
      badgesChecked: 'Badges verified',
      badgesCheckedDesc: 'Missing badge attribution completed',
      badgeError: 'Badge attribution error',
      loadError: 'Unable to load XP statistics.',
      users: 'Users',
      toSync: 'To sync',
      noBadges: 'No badges',
      totalXP: 'Total XP',
      totalUsers: 'Total users',
      needsSync: 'Need XP sync',
      calculatedXP: 'Total calculated XP',
      detailPerUser: 'Detail per user',
      xpProfile: 'Profile XP',
      xpCalculated: 'Calculated XP',
      sessions: 'Sessions',
      badges: 'Badges',
      status: 'Status',
      actions: 'Actions',
      desync: 'Out of sync',
      syncXP: 'Sync XP',
      awardBadges: 'Award badges',
      syncGlobal: 'Global Sync'
    },
    notifications2: {
      emailsSent: 'Emails sent',
      openRate: 'Open rate',
      send: 'Send',
      historyTemplates: 'History & Templates',
      sendStats: 'Send statistics',
      resetStuck: 'Reset stuck',
      resetting: 'Resetting...',
      noCampaignsStuck: 'No stuck campaigns',
      allCampaignsValid: 'All campaigns are valid',
      resetError: 'Error resetting campaigns'
    },
    promptEditor: {
      title: 'AI Prompt Management',
      description: 'Edit the system prompts used by the AI for each use case. These prompts define the assistant\'s behavior and capabilities.',
      promptType: 'Prompt type',
      language: 'Language',
      contentLabel: 'Prompt content',
      adminOnly: 'Admin only',
      contentPlaceholder: 'Enter the system prompt here...',
      contextHint: 'Use ${context} as a placeholder for user profile information.',
      advancedOptions: 'Advanced options',
      webSearch: 'Web search',
      webSearchDesc: 'Allows the AI to perform web searches to supplement its responses',
      temperature: 'Temperature',
      precise: 'Precise (0.0)',
      creative: 'Creative (1.0)',
      userContextPreview: 'User context preview',
      userLabel: 'User',
      modeLabel: 'Mode',
      serviceLabel: 'Service',
      specialtyLabel: 'Specialty',
      contextInsertHint: 'This context will be automatically inserted in place of ${context} in the prompt.',
      lastModified: 'Last modified: Now',
      reset: 'Reset',
      save: 'Save',
      promptsByLanguage: 'Prompts overview by language:',
      notConfigured: 'Not configured',
      types: {
        general: 'General',
        diagnostic: 'Diagnostic',
        priseEnCharge: 'Patient management',
        formation: 'Training',
        these: 'Thesis',
        pmsi: 'PMSI',
        rsca: 'RSCA',
        analysePrescriptions: 'Prescription Analysis',
        casComplexes: 'Complex cases',
        triage: 'Triage',
        diagnosisCoding: 'Diagnosis coding',
        prescriptionAnalysis: 'Prescription analysis (legacy)',
        patientSummary: 'Patient summary',
        qcm: 'MCQ',
        clinicalCase: 'Clinical case',
        fiche: 'Revision sheets',
        imageAnalysis: 'Image analysis',
        medicationAnalysis: 'Medication analysis',
        rcpAnalysis: 'RCP analysis',
        structureConsultation: 'Consultation structuring'
      }
    },
    challenges: {
      createTitle: 'Create a Challenge',
      createSubtitle: 'Engage your community with motivating challenges',
      newChallenge: 'Create a new challenge',
      newChallengeDesc: 'Create a weekly challenge to engage the community',
      challengeTitle: 'Challenge title',
      titlePlaceholder: 'Review 50 flashcards this week',
      description: 'Description',
      descPlaceholder: 'Describe the challenge and its objectives...',
      challengeType: 'Challenge type',
      flashcardReview: 'Flashcard review',
      quizCompletion: 'Quiz completion',
      studyTime: 'Study time (minutes)',
      goal: 'Goal',
      specialty: 'Specialty (optional)',
      specialtyPlaceholder: 'E.g. Cardiology',
      durationDays: 'Duration (days)',
      rewardXp: 'XP Reward',
      badge: 'Badge (optional)',
      creating: 'Creating...',
      createChallenge: 'Create challenge',
      cancel: 'Cancel'
    },
    systemLogs: {
      filtersAndSearch: 'Filters and search',
      search: 'Search',
      searchPlaceholder: 'Search logs...',
      period: 'Period',
      lastHour: 'Last hour',
      last24h: 'Last 24h',
      last7d: 'Last 7 days',
      last30d: 'Last 30 days',
      actionType: 'Action type',
      allActions: 'All actions',
      security: 'Security',
      errors: 'Errors',
      logins: 'Logins',
      roleChanges: 'Role changes',
      results: 'Results',
      events: '{{count}} events',
      loadingLogs: 'Loading logs...',
      securityEvents: 'Security events',
      generalActivity: 'General activity',
      securityEventsTitle: 'Security Events',
      securityEventsDesc: 'Security logs and detected violations',
      generalActivityTitle: 'General Activity',
      generalActivityDesc: 'All system and user events',
      noSecurityEvents: 'No security events found',
      goodNews: 'That\'s good news!',
      securityBadge: 'Security',
      errorBadge: 'Error',
      infoBadge: 'Info'
    },
    push: {
      testTitle: 'Push Notification Test',
      userId: 'User ID',
      userIdPlaceholder: 'User UUID',
      title: 'Title',
      titlePlaceholder: 'Notification title',
      message: 'Message',
      messagePlaceholder: 'Notification content',
      sending: 'Sending...',
      sendTest: 'Send Test',
      totalTokens: 'Total tokens',
      activeTokens: 'Active tokens',
      validWebPush: 'Valid Web Push',
      defectiveTokens: 'Defective tokens'
    },
    pushManager: {
      title: 'Push Notifications',
      subtitle: 'Send push notifications directly to user devices',
      totalDevices: 'Total devices',
      activeDevices: 'Active',
      validWebPush: 'Valid Web Push',
      invalidTokens: 'Invalid tokens',
      deliveryRate: 'Delivery rate',
      platformBreakdown: 'Platform breakdown',
      userSegmentation: 'User segmentation',
      trialExpired: 'Trial expired',
      activeSubscribers: 'Active subscribers',
      free: 'Free',
      premium: 'Premium',
      inactive: 'Inactive',
      sendNotification: 'Send a notification',
      notifTitle: 'Title',
      notifTitlePlaceholder: 'Notification title',
      notifMessage: 'Message',
      notifMessagePlaceholder: 'Notification content',
      chars: '{{count}}/{{max}} characters',
      targetUrl: 'Destination URL (optional)',
      targetUrlPlaceholder: 'https://example.com/target-page',
      targetUrlHint: 'The user will be redirected to this URL when clicking the notification',
      targetAudience: 'Target audience',
      allUsers: 'All users',
      subscribers: 'Active subscribers',
      trialExpiredOption: 'Trial period expired',
      bySubscriptionTier: 'By subscription tier',
      byRole: 'By specific role',
      inactiveUsers: 'Inactive users',
      specificRole: 'Specific role',
      selectRole: 'Select a role',
      doctors: 'Doctors',
      nurses: 'Nurses',
      residents: 'Residents',
      users: 'Users',
      subscriptionTier: 'Subscription tier',
      selectTier: 'Select a tier',
      basic: 'Basic',
      enterprise: 'Enterprise',
      audiencePreview: 'Audience preview: {{count}} targeted user(s)',
      target: 'Target',
      undefined: 'Undefined',
      sending: 'Sending...',
      send: 'Send',
      requiredFields: 'Required fields',
      fillTitleAndMessage: 'Please fill in the title and message',
      notifSent: 'Notification sent!',
      notifSentDesc: '{{count}} notifications sent successfully',
      sendError: 'Send error',
      sendErrorDesc: 'Unable to send the notification'
    },
    usageBreakdown: {
      loading: 'Loading...',
      filtersAndSearch: 'Filters and search',
      search: 'Search',
      functionPlaceholder: 'Function name...',
      function: 'Function',
      allFunctions: 'All functions',
      model: 'Model',
      allModels: 'All models',
      period: 'Period',
      last7d: 'Last 7 days',
      last30d: 'Last 30 days',
      last90d: 'Last 90 days',
      totalCost: 'Total cost',
      tokensIn: 'Tokens IN',
      tokensOut: 'Tokens OUT',
      avgCostPerRequest: 'Avg cost/request',
      totalRequests: 'Total requests',
      displayed: '({{count}} displayed)',
      dailyUsage: 'Daily usage',
      topFunctions: 'Most used functions',
      costEur: 'Cost (€)',
      detailedLogs: 'Detailed logs ({{count}} results)',
      date: 'Date',
      cost: 'Cost'
    },
    emailSender: {
      sendNotification: 'Send a notification',
      createAndSend: 'Create and quickly send emails to your users',
      directEmail: 'Direct email',
      useTemplate: 'Use a template',
      selectTemplate: 'Select a template',
      chooseTemplate: 'Choose a template...',
      campaignName: 'Campaign name (optional)',
      campaignNamePlaceholder: 'E.g.: New features announcement',
      targetAudience: 'Target audience',
      testEmail: 'Test email',
      testEmailLabel: 'Test email address',
      testEmailPlaceholder: 'test@example.com',
      audienceTestEmail: 'Test email',
      audienceTestEmailDesc: 'Send to a specific email address for testing',
      audienceAll: 'All users',
      audienceAllDesc: 'Send to all active users',
      audienceTrialExpired: 'Expired trials',
      audienceTrialExpiredDesc: 'Users whose trial has expired without conversion',
      audienceInactive7d: 'Inactive 7+ days',
      audienceInactive7dDesc: 'Users inactive for more than 7 days',
      audienceInactive30d: 'Inactive 30+ days',
      audienceInactive30dDesc: 'Users inactive for more than 30 days',
      audienceSubscribed: 'Paid subscribers',
      audienceSubscribedDesc: 'Users with an active subscription',
      audienceFreeTier: 'Free tier',
      audienceFreeTierDesc: 'Users on the free version',
      recipients: '{{count}} recipients',
      sendEstimation: 'Estimated send in ~{{days}} day(s) (limit: {{limit}}/day)',
      emailSubject: 'Email subject',
      emailSubjectPlaceholder: '🚀 Discover what\'s new in Sclépios!',
      htmlContent: 'HTML content',
      preview: 'Preview',
      availableVars: 'Available variables',
      scheduleOptional: 'Schedule send (optional)',
      sendingInProgress: 'Sending...',
      scheduleSend: 'Schedule send',
      sendNow: 'Send now',
      largeWarning: 'This campaign will be sent gradually over {{days}} day(s) to respect the {{limit}} emails/day limit.',
      emailPreview: 'Email preview',
      subject: 'Subject',
      mustBeLoggedIn: 'You must be logged in',
      fillSubjectAndContent: 'Please fill in the subject and content',
      subjectNotEmail: 'The subject cannot be an email address',
      invalidTestEmail: 'Please enter a valid email address for testing',
      campaignSent: 'Campaign sent!',
      campaignSentDesc: '{{count}} emails queued. Estimate: ~{{days}} day(s)',
      campaignScheduled: 'Campaign scheduled',
      campaignScheduledDesc: 'Scheduled for {{date}}',
      sendCampaignError: 'Unable to send campaign'
    },
    campaignHistory: {
      title: 'Campaign history',
      search: 'Search...',
      status: 'Status',
      all: 'All',
      sent: 'Sent',
      queued: 'Queued',
      sendingStatus: 'Sending...',
      scheduled: 'Scheduled',
      draft: 'Draft',
      failed: 'Failed',
      sentFilter: 'Sent',
      queuedFilter: 'Queued',
      scheduledFilter: 'Scheduled',
      draftsFilter: 'Drafts',
      failedFilter: 'Failed',
      loading: 'Loading...',
      noCampaigns: 'No campaigns found',
      openings: 'opens',
      deleteCampaignTitle: 'Delete campaign?',
      deleteCampaignDesc: 'This action is irreversible. Associated queued emails will also be deleted.',
      cancel: 'Cancel',
      delete: 'Delete',
      campaignSent: 'Campaign sent!',
      campaignSentDesc: '{{count}} emails queued',
      sendError: 'Unable to send campaign',
      campaignDeleted: 'Campaign deleted',
      deleteError: 'Unable to delete campaign'
    },
    templateList: {
      emailTemplates: 'Email templates',
      newTemplate: 'New template',
      searchPlaceholder: 'Search templates...',
      marketing: 'Marketing',
      system: 'System',
      loading: 'Loading...',
      noMarketingTemplates: 'No marketing templates. Create one!',
      noSystemTemplates: 'No system templates found',
      inactive: 'Inactive',
      editTemplate: 'Edit template',
      previewAndTest: 'Preview and send test',
      deleteTemplate: 'Delete template',
      deleteTitle: 'Delete template?',
      deleteDesc: 'This action is irreversible. Campaigns using this template will no longer be sendable.',
      cancel: 'Cancel',
      delete: 'Delete',
      templateDeleted: 'Template deleted',
      deleteError: 'Unable to delete template'
    },
    calculator: {
      calculator: 'Calculator',
      favorites: 'Favorites',
      history: 'History',
      searchPlaceholder: 'Search calculator...',
      category: 'Category',
      allCategories: 'All categories',
      noFavorites: 'No favorite calculators',
      addFavoriteHint: 'Click the star to add your preferred calculators',
      calculationHistory: 'Calculation history',
      export: 'Export',
      noHistory: 'No calculations in history',
      recentCalcsHint: 'Your recent calculations will appear here'
    },
    costAlerts: {
      roiCritical: 'Critical ROI',
      roiCriticalMsg: 'AI costs represent {{percent}}% of monthly revenue',
      dailyCostHigh: 'High Daily Cost',
      dailyCostHighMsg: 'Monthly projection: €{{projected}} (daily cost: €{{daily}})',
      budgetExceeded: 'Budget Exceeded',
      budgetExceededMsg: 'Current monthly cost: €{{current}} (limit: €{{limit}})',
      testAlertTitle: 'Cost Alert Test',
      testAlertMsg: 'Test notification from alert system'
    },
    subscriptions: {
      monthly: 'Monthly',
      annual: 'Annual',
      trial: 'Free trial',
      premiumFree: 'Premium free',
      expired: 'Expired',
      free: 'Free'
    }
  },
  es: {
    title: 'Administración',
    subtitle: 'Panel de Administración',
    accessDenied: 'Acceso denegado',
    restrictedAccess: 'Acceso Restringido',
    restrictedMessage: 'Debes ser administrador para acceder a esta página.',
    loading: 'Cargando datos...',
    refresh: 'Actualizar',
    checkingPermissions: 'Verificando permisos...',
    sidebar: {
      dashboard: 'Dashboard',
      engagement: 'Engagement',
      stats: 'Estadísticas',
      aiPrompts: 'Prompts IA',
      mailing: 'Mailing',
      users: 'Usuarios',
      xpBadges: 'XP & Insignias',
      createChallenge: 'Crear Desafío',
      systemLogs: 'Logs del Sistema',
      expiredCleanup: 'Limpieza Expirados'
    },
    pushTest: {
      title: 'Test de notificaciones push web',
      description: 'Envíe una notificación de prueba a todos los usuarios con tokens activos',
      fillTitleMessage: 'Por favor, complete el título y el mensaje',
      sent: '✅ Notificación enviada',
      sentCount: '{{count}} notificación(es) enviada(s) con éxito',
      sendError: 'No se pudo enviar la notificación'
    },
    stats: {
      totalUsers: 'Usuarios Totales',
      newThisMonth: '{{count}} nuevos este mes',
      paidUsers: 'Usuarios de Pago',
      percentOfTotal: '{{percent}}% del total',
      roi: 'ROI Mensual',
      revenueMinusCosts: 'Ingresos - Costos',
      trials: 'Pruebas Gratuitas',
      expired: '{{count}} expiradas'
    },
    tabs: {
      users: 'Usuarios',
      api: 'API',
      revenue: 'Ingresos'
    },
    api: {
      callsLast30Days: 'Llamadas API (30d)',
      averagePerDay: '{{count}} por día promedio',
      totalCost30Days: 'Costo Total (30d)',
      perDay: '€{{amount}} por día',
      averageCostPerCall: 'Costo Promedio/Llamada',
      averageUnitPrice: 'Precio unitario promedio',
      recentActivity: 'Actividad API Reciente',
      last10Calls: 'Últimas 10 llamadas API',
      tokens: '{{count}} tokens'
    },
    revenue: {
      breakdown: 'Desglose de Ingresos',
      monthlyRevenueByType: 'Ingresos mensuales por tipo de suscripción',
      monthlySubscriptions: 'Suscripciones mensuales',
      annualSubscriptions: 'Suscripciones anuales',
      monthlyTotal: 'Total mensual',
      userDistribution: 'Distribución de Usuarios',
      distributionByStatus: 'Distribución por estado de suscripción',
      paidSubscribers: 'Suscriptores de pago',
      onTrial: 'En prueba',
      premiumFree: 'Premium gratuito',
      expiredTrials: 'Pruebas expiradas'
    },
    notifications: {
      title: 'Notificaciones',
      subtitle: 'Gestiona tus plantillas, campañas y análisis de email',
      preview: 'Vista previa',
      export: 'Exportar',
      new: 'Nuevo',
      search: 'Buscar plantillas, campañas...',
      all: 'Todos',
      email: 'Email',
      notification: 'Notificación',
      stats: {
        emailsSent: 'Emails enviados',
        thisMonth: 'Este mes',
        openRate: 'Tasa de apertura',
        average: 'Promedio',
        activeTemplates: 'Plantillas activas',
        available: 'Disponibles',
        campaigns: 'Campañas',
        total: 'Total'
      },
      campaigns: {
        title: 'Campañas de email',
        subtitle: 'Gestiona y lanza tus campañas de email',
        newCampaign: 'Nueva campaña',
        noCampaignsFound: 'No se encontraron campañas',
        noMatch: 'Ninguna campaña coincide con tu búsqueda',
        getStarted: 'Comienza creando tu primera campaña',
        createCampaign: 'Crear campaña',
        sent: 'enviados',
        template: 'Plantilla'
      },
      templates: {
        title: 'Plantillas de email',
        subtitle: 'Crea y gestiona tus plantillas de email',
        newTemplate: 'Nueva plantilla',
        noTemplatesFound: 'No se encontraron plantillas',
        noMatch: 'Ninguna plantilla coincide con tu búsqueda',
        getStarted: 'Comienza creando tu primera plantilla',
        createTemplate: 'Crear plantilla',
        active: 'Activa',
        inactive: 'Inactiva'
      },
      tabs: {
        campaigns: 'Campañas',
        templates: 'Plantillas',
        push: 'Push',
        actions: 'Acciones',
        analytics: 'Análisis'
      },
      quickActions: {
        title: 'Acciones rápidas',
        subtitle: 'Herramientas para crear y enviar rápidamente'
      },
      analytics: {
        title: 'Análisis de email',
        subtitle: 'Analiza el rendimiento de tus campañas',
        noCampaignsSent: 'No se han enviado campañas',
        analysisDescription: 'Los análisis aparecerán aquí una vez que hayas creado y enviado tus primeras campañas de email.',
        createFirstCampaign: 'Crear mi primera campaña',
        campaignPerformance: 'Rendimiento de campañas',
        noCampaignsSentYet: 'Aún no se han enviado campañas',
        emailsSent: 'enviados',
        opened: 'abiertos',
        openRate: 'Tasa de apertura'
      },
      toasts: {
        error: 'Error',
        cannotLoadData: 'No se pueden cargar los datos de email',
        confirmDeleteTemplate: '¿Estás seguro de que quieres eliminar esta plantilla?',
        templateDeleted: 'Plantilla eliminada exitosamente',
        cannotDeleteTemplate: 'No se puede eliminar la plantilla',
        confirmDeleteCampaign: '¿Estás seguro de que quieres eliminar esta campaña?',
        campaignDeleted: 'Campaña eliminada exitosamente',
        cannotDeleteCampaign: 'No se puede eliminar la campaña',
        campaignSent: '¡Campaña enviada!',
        emailsSentSuccess: '{{count}} emails enviados exitosamente',
        sendError: 'Error de envío',
        cannotSendCampaign: 'No se puede enviar la campaña',
        templatesExported: 'Plantillas exportadas exitosamente'
      }
    },
    dashboard: {
      securityAnalysis: 'Análisis de seguridad en curso...',
      noIssues: 'No se detectaron problemas en la base de datos',
      issuesDetected: '{{count}} problema(s) detectado(s): {{types}}',
      repairing: 'Reparando...',
      repairComplete: 'Reparación completa: {{count}} problema(s) corregido(s)',
      error: 'Error: {{message}}',
      unknownError: 'Error desconocido',
      trialSyncing: 'Sincronizando pruebas expiradas...',
      trialSyncComplete: 'Sincronización completa: {{count}} corrección(es)',
      trialSyncError: 'Error de sincronización: {{message}}',
      database: 'Base de datos',
      security: 'Seguridad',
      performance: 'Rendimiento',
      maintenanceActions: 'Acciones de mantenimiento',
      maintenanceDesc: 'Herramientas de diagnóstico y reparación para la estabilidad del sistema',
      auditing: 'Auditando...',
      auditAndRepair: 'Auditoría y reparación',
      syncExpiredTrials: 'Sincronizar pruebas expiradas',
      auditDesc: 'Detecta y corrige inconsistencias en datos de usuario',
      syncDesc: 'Fuerza la sincronización de pruebas expiradas',
      recentActivity: 'Actividad reciente',
      lastCheck: 'Última verificación',
      securityAlerts: 'Alertas de seguridad',
      criticalAlerts: 'Alertas críticas',
      optimizationSuggested: 'Optimización sugerida',
      issuesDetectedTitle: '{{count}} problema(s) detectado(s)',
      confirmRepair: '¿Desea iniciar la reparación automática?',
      cancel: 'Cancelar',
      repair: 'Reparar'
    },
    engagement: {
      activeUsers7d: 'Usuarios activos (7d)',
      activeUsers30d: 'Usuarios activos (30d)',
      retention30d: 'Retención a 30 días',
      completedProfiles: 'Perfiles completados',
      incompleteProfiles: '{{count}} perfiles incompletos',
      churnRisk: 'Riesgo de abandono',
      alreadyChurned: '{{count}} ya abandonados (30d+)',
      ofTotalUsers: 'De {{count}} usuarios',
      churnWarning: '⚠️ {{count}} usuarios en riesgo de abandono (14-30d inactivos)',
      engagementByFeature: 'Engagement por funcionalidad (7 días)',
      interactionsPerFeature: 'Número de interacciones por funcionalidad',
      quizCompleted: 'Quiz completados',
      flashcardReviews: 'Revisiones de flashcards',
      aiChatMessages: 'Mensajes chat IA',
      forumPosts: 'Posts del foro',
      gamification: 'Gamificación',
      badgesAndRewards: 'Badges y recompensas',
      badgesAwarded: 'Badges otorgados',
      usersWithBadges: 'Usuarios con badges',
      ofUsers: '{{percent}}% de usuarios'
    },
    filters: {
      searchPlaceholder: 'Buscar por nombre o email...',
      activeFilters: 'Filtros activos:',
      filter: '{{count}} filtro(s)',
      clearFilters: 'Borrar todos los filtros',
      clearLabel: 'Borrar filtros',
      all: 'Todos',
      allFeminine: 'Todas',
      subscriptionStatus: 'Estado de suscripción',
      subscribed: 'Suscriptores de pago',
      trial: 'En prueba',
      free: 'Gratuitos',
      role: 'Rol',
      admin: 'Admin',
      moderator: 'Moderador',
      user: 'Usuario',
      trialStatus: 'Estado de prueba',
      activeTrial: 'Prueba activa',
      expiredTrial: 'Prueba expirada',
      noTrial: 'Sin prueba',
      period: 'Período',
      today: 'Hoy',
      thisWeek: 'Esta semana',
      thisMonth: 'Este mes',
      thisQuarter: 'Este trimestre',
      exportCsv: 'Exportar CSV',
      usersCount: '{{filtered}} / {{total}} usuarios',
    },
    prompts: {
      loadError: 'Error al cargar los prompts',
      savedTranslated: 'Prompt guardado y {{count}} traducción(es) generada(s) automáticamente',
      savedNoTranslation: 'Prompt guardado pero sin traducciones generadas',
      savedTranslationFailed: 'Prompt guardado pero la traducción automática falló',
      savedSuccess: 'Prompt guardado con éxito',
      saveError: 'Error al guardar: {{message}}',
      searchPlaceholder: 'Buscar prompts...',
      status: 'Estado',
      all: 'Todos',
      active: 'Activo',
      draft: 'Borrador',
      archived: 'Archivado',
      newPrompt: 'Nuevo Prompt',
      createTitle: 'Crear nuevo prompt',
      createDesc: 'Cree un nuevo template de prompt IA para la aplicación.',
      editTitle: 'Modificar el prompt',
      editDesc: 'Modifique los detalles de este template de prompt IA.',
      titleLabel: 'Título',
      useCase: 'Caso de uso',
      selectUseCase: 'Seleccionar un caso de uso',
      statusLabel: 'Estado',
      content: 'Contenido',
      contentPlaceholder: 'Escriba su prompt aquí...',
      tags: 'Tags',
      cancel: 'Cancelar',
      create: 'Crear',
      save: 'Guardar',
      tableTitle: 'Título',
      tableUseCase: 'Caso de uso',
      tableStatus: 'Estado',
      tableTags: 'Tags',
      tableUpdated: 'Actualizado',
      loading: 'Cargando prompts...',
      noPrompts: 'Ningún prompt encontrado',
      edit: 'Modificar',
      archive: 'Archivar',
      delete: 'Eliminar',
      confirmDelete: 'Confirmar eliminación',
      confirmDeleteDesc: '¿Está seguro de querer eliminar este prompt? Esta acción es irreversible.'
    },
    promptEditor: {
      title: 'Gestión de Prompts IA',
      description: 'Edite los prompts del sistema utilizados por la IA para cada caso de uso. Estos prompts definen el comportamiento y las capacidades del asistente.',
      promptType: 'Tipo de prompt',
      language: 'Idioma',
      contentLabel: 'Contenido del prompt',
      adminOnly: 'Solo admin',
      contentPlaceholder: 'Ingrese el prompt del sistema aquí...',
      contextHint: 'Use ${context} como marcador para la información del perfil del usuario.',
      advancedOptions: 'Opciones avanzadas',
      webSearch: 'Búsqueda web',
      webSearchDesc: 'Permite a la IA realizar búsquedas web para complementar sus respuestas',
      temperature: 'Temperatura',
      precise: 'Preciso (0.0)',
      creative: 'Creativo (1.0)',
      userContextPreview: 'Vista previa del contexto del usuario',
      userLabel: 'Usuario',
      modeLabel: 'Modo',
      serviceLabel: 'Servicio',
      specialtyLabel: 'Especialidad',
      contextInsertHint: 'Este contexto se insertará automáticamente en lugar de ${context} en el prompt.',
      lastModified: 'Última modificación: Ahora',
      reset: 'Restablecer',
      save: 'Guardar',
      promptsByLanguage: 'Resumen de prompts por idioma:',
      notConfigured: 'No configurado',
      types: {
        general: 'General',
        diagnostic: 'Diagnóstico',
        priseEnCharge: 'Manejo del paciente',
        formation: 'Formación',
        these: 'Tesis',
        pmsi: 'PMSI',
        rsca: 'RSCA',
        analysePrescriptions: 'Análisis de prescripciones',
        casComplexes: 'Casos complejos',
        triage: 'Triaje',
        diagnosisCoding: 'Codificación diagnóstica',
        prescriptionAnalysis: 'Análisis prescripciones (legacy)',
        patientSummary: 'Resumen del paciente',
        qcm: 'MCQ',
        clinicalCase: 'Caso clínico',
        fiche: 'Fichas de revisión',
        imageAnalysis: 'Análisis de imagen',
        medicationAnalysis: 'Análisis de medicamentos',
        rcpAnalysis: 'Análisis RCP',
        structureConsultation: 'Estructuración de consulta'
      }
    },
    templateEditor: {
      types: {
        system: 'Sistema',
        community: 'Comunidad',
        progression: 'Progresión',
        reminder: 'Recordatorio',
        security: 'Seguridad',
        marketing: 'Marketing',
        reactivation: 'Reactivación',
      }
    },
    templates: {
      editTemplate: 'Modificar template',
      newTemplate: 'Nuevo template',
      createDesc: 'Cree o modifique un template de email para sus campañas de notificaciones',
      name: 'Nombre del template',
      namePlaceholder: 'Ej: Email de bienvenida',
      type: 'Tipo',
      channel: 'Canal',
      subject: 'Asunto',
      subjectPlaceholder: 'Asunto del email',
      availableVars: 'Variables disponibles',
      selectedVars: 'Variables seleccionadas',
      htmlContent: 'Contenido HTML',
      pushMessage: 'Mensaje',
      pushPlaceholder: 'Mensaje de la notificación push...',
      htmlPlaceholder: 'Contenido HTML del email...',
      textContent: 'Contenido texto (opcional)',
      textPlaceholder: 'Versión texto del email...',
      activeTemplate: 'Template activo',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      save: 'Guardar',
      preview: 'Vista previa',
      previewTitle: 'Vista previa del template',
      close: 'Cerrar',
      previewTemplates: 'Vista previa de Templates',
      previewDesc: 'Previsualice y pruebe sus templates de email con los diseños Sclépios',
      selectTemplate: 'Seleccionar un template',
      templateVars: 'Variables del template',
      varPlaceholder: 'Valor para {{{{var}}}}',
      testSend: 'Envío de prueba',
      testEmail: 'Email de prueba',
      sending: 'Enviando...',
      sendTest: 'Enviar prueba',
      templateInfo: 'Información del template',
      variables: 'Variables',
      noVars: 'Ninguna',
      emailPreview: 'Vista previa del email',
      selectForPreview: 'Seleccione un template para la vista previa'
    },
    cleanup: {
      timeline: 'Timeline de procesamiento ({{count}} usuarios)',
      searchEmail: 'Buscar por email...',
      filterByStage: 'Filtrar por etapa',
      allStages: 'Todas las etapas',
      warningSent: 'Advertencia enviada',
      scheduledDeletion: 'Eliminación programada',
      deleted: 'Eliminado',
      warningShort: 'Advertido',
      scheduledShort: 'Programado',
      email: 'Email',
      currentStage: 'Etapa actual',
      warningDate: 'Advertencia enviada',
      deletionDate: 'Eliminación programada',
      showing: 'Mostrando {{from}} a {{to}} de {{total}} resultados',
      previous: 'Anterior',
      previousShort: 'Ant.',
      next: 'Siguiente',
      nextShort: 'Sig.',
      page: 'Página {{current}} de {{total}}',
      inactiveUsers: 'Usuarios inactivos',
      identifiedInactive: 'Identificados como inactivos',
      warningsSent: 'Advertencias enviadas',
      usersWarned: 'Usuarios advertidos',
      scheduledDeletions: 'Eliminaciones programadas',
      deletionIn30Days: 'Eliminación en 30 días',
      completedDeletions: 'Eliminaciones realizadas',
      deletedAccounts: 'Cuentas eliminadas',
      lastExecution: 'Última ejecución',
      usersScanned: 'usuarios escaneados',
      emailsSimulated: 'emails simulados',
      emailsSent: 'emails enviados',
      deletionsSimulated: 'eliminaciones simuladas',
      deletionsReal: 'eliminaciones reales',
      success: 'Éxito',
      failure: 'Fallo',
      noActionApplied: 'Ninguna acción aplicada',
      testDryRun: 'Test (dry run)'
    },
    challenges: {
      createTitle: 'Crear un Desafío',
      createSubtitle: 'Involucra a tu comunidad con desafíos motivadores',
      newChallenge: 'Crear un nuevo desafío',
      newChallengeDesc: 'Crea un desafío semanal para involucrar a la comunidad',
      challengeTitle: 'Título del desafío',
      titlePlaceholder: 'Revisa 50 flashcards esta semana',
      description: 'Descripción',
      descPlaceholder: 'Describe el desafío y sus objetivos...',
      challengeType: 'Tipo de desafío',
      flashcardReview: 'Revisión de flashcards',
      quizCompletion: 'Completar quiz',
      studyTime: 'Tiempo de estudio (minutos)',
      goal: 'Objetivo',
      specialty: 'Especialidad (opcional)',
      specialtyPlaceholder: 'Ej: Cardiología',
      durationDays: 'Duración (días)',
      rewardXp: 'Recompensa XP',
      badge: 'Badge (opcional)',
      creating: 'Creando...',
      createChallenge: 'Crear desafío',
      cancel: 'Cancelar'
    },
    systemLogs: {
      filtersAndSearch: 'Filtros y búsqueda',
      search: 'Búsqueda',
      searchPlaceholder: 'Buscar en los logs...',
      period: 'Período',
      lastHour: 'Última hora',
      last24h: 'Últimas 24h',
      last7d: 'Últimos 7 días',
      last30d: 'Últimos 30 días',
      actionType: 'Tipo de acción',
      allActions: 'Todas las acciones',
      security: 'Seguridad',
      errors: 'Errores',
      logins: 'Conexiones',
      roleChanges: 'Cambios de rol',
      results: 'Resultados',
      events: '{{count}} eventos',
      loadingLogs: 'Cargando logs...',
      securityEvents: 'Eventos de seguridad',
      generalActivity: 'Actividad general',
      securityEventsTitle: 'Eventos de Seguridad',
      securityEventsDesc: 'Logs de seguridad y violaciones detectadas',
      generalActivityTitle: 'Actividad General',
      generalActivityDesc: 'Todos los eventos del sistema y usuario',
      noSecurityEvents: 'No se encontraron eventos de seguridad',
      goodNews: '¡Es una buena noticia!',
      securityBadge: 'Seguridad',
      errorBadge: 'Error',
      infoBadge: 'Info'
    },
    push: {
      testTitle: 'Test de Notificación Push',
      userId: 'ID Usuario',
      userIdPlaceholder: 'UUID del usuario',
      title: 'Título',
      titlePlaceholder: 'Título de la notificación',
      message: 'Mensaje',
      messagePlaceholder: 'Contenido de la notificación',
      sending: 'Enviando...',
      sendTest: 'Enviar Test',
      totalTokens: 'Total tokens',
      activeTokens: 'Tokens activos',
      validWebPush: 'Web Push válidos',
      defectiveTokens: 'Tokens defectuosos'
    },
    pushManager: {
      title: 'Notificaciones Push',
      subtitle: 'Envíe notificaciones push directamente a los dispositivos de los usuarios',
      totalDevices: 'Dispositivos totales',
      activeDevices: 'Activos',
      validWebPush: 'Web Push válidos',
      invalidTokens: 'Tokens inválidos',
      deliveryRate: 'Tasa de entrega',
      platformBreakdown: 'Distribución por plataforma',
      userSegmentation: 'Segmentación de usuarios',
      trialExpired: 'Prueba expirada',
      activeSubscribers: 'Suscriptores activos',
      free: 'Gratuito',
      premium: 'Premium',
      inactive: 'Inactivos',
      sendNotification: 'Enviar una notificación',
      notifTitle: 'Título',
      notifTitlePlaceholder: 'Título de la notificación',
      notifMessage: 'Mensaje',
      notifMessagePlaceholder: 'Contenido de la notificación',
      chars: '{{count}}/{{max}} caracteres',
      targetUrl: 'URL de destino (opcional)',
      targetUrlPlaceholder: 'https://ejemplo.com/pagina-destino',
      targetUrlHint: 'El usuario será redirigido a esta URL al hacer clic en la notificación',
      targetAudience: 'Audiencia objetivo',
      allUsers: 'Todos los usuarios',
      subscribers: 'Suscriptores activos',
      trialExpiredOption: 'Período de prueba expirado',
      bySubscriptionTier: 'Por nivel de suscripción',
      byRole: 'Por rol específico',
      inactiveUsers: 'Usuarios inactivos',
      specificRole: 'Rol específico',
      selectRole: 'Seleccionar un rol',
      doctors: 'Doctores',
      nurses: 'Enfermeros',
      residents: 'Residentes',
      users: 'Usuarios',
      subscriptionTier: 'Nivel de suscripción',
      selectTier: 'Seleccionar un nivel',
      basic: 'Basic',
      enterprise: 'Enterprise',
      audiencePreview: 'Vista previa de audiencia: {{count}} usuario(s) objetivo',
      target: 'Objetivo',
      undefined: 'No definido',
      sending: 'Enviando...',
      send: 'Enviar',
      requiredFields: 'Campos requeridos',
      fillTitleAndMessage: 'Por favor complete el título y el mensaje',
      notifSent: '¡Notificación enviada!',
      notifSentDesc: '{{count}} notificaciones enviadas con éxito',
      sendError: 'Error de envío',
      sendErrorDesc: 'No se pudo enviar la notificación'
    },
    usageBreakdown: {
      loading: 'Cargando...',
      filtersAndSearch: 'Filtros y búsqueda',
      search: 'Buscar',
      functionPlaceholder: 'Nombre de función...',
      function: 'Función',
      allFunctions: 'Todas las funciones',
      model: 'Modelo',
      allModels: 'Todos los modelos',
      period: 'Período',
      last7d: 'Últimos 7 días',
      last30d: 'Últimos 30 días',
      last90d: 'Últimos 90 días',
      totalCost: 'Costo total',
      tokensIn: 'Tokens IN',
      tokensOut: 'Tokens OUT',
      avgCostPerRequest: 'Costo prom./solicitud',
      totalRequests: 'Solicitudes totales',
      displayed: '({{count}} mostradas)',
      dailyUsage: 'Uso diario',
      topFunctions: 'Funciones más utilizadas',
      costEur: 'Costo (€)',
      detailedLogs: 'Logs detallados ({{count}} resultados)',
      date: 'Fecha',
      cost: 'Costo'
    },
    emailSender: {
      sendNotification: 'Enviar una notificación',
      createAndSend: 'Cree y envíe rápidamente emails a sus usuarios',
      directEmail: 'Email directo',
      useTemplate: 'Usar un template',
      selectTemplate: 'Seleccionar un template',
      chooseTemplate: 'Elegir un template...',
      campaignName: 'Nombre de la campaña (opcional)',
      campaignNamePlaceholder: 'Ej: Anuncio nuevas funcionalidades',
      targetAudience: 'Audiencia objetivo',
      testEmail: 'Email de prueba',
      testEmailLabel: 'Dirección email de prueba',
      testEmailPlaceholder: 'test@ejemplo.com',
      audienceTestEmail: 'Email de prueba',
      audienceTestEmailDesc: 'Enviar a una dirección email específica para probar',
      audienceAll: 'Todos los usuarios',
      audienceAllDesc: 'Enviar a todos los usuarios activos',
      audienceTrialExpired: 'Pruebas expiradas',
      audienceTrialExpiredDesc: 'Usuarios cuya prueba ha expirado sin conversión',
      audienceInactive7d: 'Inactivos +7 días',
      audienceInactive7dDesc: 'Usuarios inactivos desde hace más de 7 días',
      audienceInactive30d: 'Inactivos +30 días',
      audienceInactive30dDesc: 'Usuarios inactivos desde hace más de 30 días',
      audienceSubscribed: 'Suscriptores de pago',
      audienceSubscribedDesc: 'Usuarios con una suscripción activa',
      audienceFreeTier: 'Nivel gratuito',
      audienceFreeTierDesc: 'Usuarios en versión gratuita',
      recipients: '{{count}} destinatarios',
      sendEstimation: 'Envío estimado en ~{{days}} día(s) (límite: {{limit}}/día)',
      emailSubject: 'Asunto del email',
      emailSubjectPlaceholder: '🚀 ¡Descubra las novedades de Sclépios!',
      htmlContent: 'Contenido HTML',
      preview: 'Vista previa',
      availableVars: 'Variables disponibles',
      scheduleOptional: 'Programar envío (opcional)',
      sendingInProgress: 'Enviando...',
      scheduleSend: 'Programar envío',
      sendNow: 'Enviar ahora',
      largeWarning: 'Esta campaña se enviará progresivamente durante {{days}} día(s) para respetar el límite de {{limit}} emails/día.',
      emailPreview: 'Vista previa del email',
      subject: 'Asunto',
      mustBeLoggedIn: 'Debe estar conectado',
      fillSubjectAndContent: 'Por favor complete el asunto y el contenido',
      subjectNotEmail: 'El asunto no puede ser una dirección email',
      invalidTestEmail: 'Por favor ingrese una dirección email válida para la prueba',
      campaignSent: '¡Campaña enviada!',
      campaignSentDesc: '{{count}} emails en cola. Estimación: ~{{days}} día(s)',
      campaignScheduled: 'Campaña programada',
      campaignScheduledDesc: 'Envío previsto el {{date}}',
      sendCampaignError: 'No se pudo enviar la campaña'
    },
    campaignHistory: {
      title: 'Historial de campañas',
      search: 'Buscar...',
      status: 'Estado',
      all: 'Todos',
      sent: 'Enviado',
      queued: 'En cola',
      sendingStatus: 'Enviando...',
      scheduled: 'Programado',
      draft: 'Borrador',
      failed: 'Fallido',
      sentFilter: 'Enviados',
      queuedFilter: 'En cola',
      scheduledFilter: 'Programados',
      draftsFilter: 'Borradores',
      failedFilter: 'Fallidos',
      loading: 'Cargando...',
      noCampaigns: 'No se encontraron campañas',
      openings: 'aperturas',
      deleteCampaignTitle: '¿Eliminar campaña?',
      deleteCampaignDesc: 'Esta acción es irreversible. Los emails en cola asociados también serán eliminados.',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      campaignSent: '¡Campaña enviada!',
      campaignSentDesc: '{{count}} emails en cola',
      sendError: 'No se pudo enviar la campaña',
      campaignDeleted: 'Campaña eliminada',
      deleteError: 'No se pudo eliminar la campaña'
    },
    templateList: {
      emailTemplates: 'Templates de email',
      newTemplate: 'Nuevo template',
      searchPlaceholder: 'Buscar template...',
      marketing: 'Marketing',
      system: 'Sistema',
      loading: 'Cargando...',
      noMarketingTemplates: '¡No hay templates de marketing. Cree uno!',
      noSystemTemplates: 'No se encontraron templates de sistema',
      inactive: 'Inactivo',
      editTemplate: 'Editar template',
      previewAndTest: 'Previsualizar y enviar prueba',
      deleteTemplate: 'Eliminar template',
      deleteTitle: '¿Eliminar template?',
      deleteDesc: 'Esta acción es irreversible. Las campañas que usen este template no podrán ser enviadas.',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      templateDeleted: 'Template eliminado',
      deleteError: 'No se pudo eliminar el template'
    },
    calculator: {
      calculator: 'Calculadora',
      favorites: 'Favoritos',
      history: 'Historial',
      searchPlaceholder: 'Buscar cálculo...',
      category: 'Categoría',
      allCategories: 'Todas las categorías',
      noFavorites: 'Ninguna calculadora en favoritos',
      addFavoriteHint: 'Haga clic en la estrella para agregar sus calculadoras preferidas',
      calculationHistory: 'Historial de cálculos',
      export: 'Exportar',
      noHistory: 'Ningún cálculo en el historial',
      recentCalcsHint: 'Sus cálculos recientes aparecerán aquí'
    },
    xpBadge: {
      syncSuccess: 'Sincronización exitosa',
      syncSuccessDesc: 'XP sincronizados: {{xp}} XP, nivel {{level}}',
      syncGlobalDone: 'Sincronización global completada',
      syncGlobalDesc: '{{users}} usuarios sincronizados, {{xp}} XP recuperados',
      syncError: 'Error de sincronización',
      syncGlobalError: 'Error de sincronización global',
      badgesChecked: 'Insignias verificadas',
      badgesCheckedDesc: 'Atribución de insignias faltantes completada',
      badgeError: 'Error atribución insignias',
      loadError: 'Imposible cargar las estadísticas XP.',
      users: 'Usuarios',
      toSync: 'Por sincronizar',
      noBadges: 'Sin insignias',
      totalXP: 'XP total',
      totalUsers: 'Usuarios total',
      needsSync: 'Necesitan sync XP',
      calculatedXP: 'XP total calculado',
      detailPerUser: 'Detalle por usuario',
      xpProfile: 'XP Perfil',
      xpCalculated: 'XP Calculado',
      sessions: 'Sesiones',
      badges: 'Insignias',
      status: 'Estado',
      actions: 'Acciones',
      desync: 'Desincronizado',
      syncXP: 'Sincronizar XP',
      awardBadges: 'Atribuir insignias',
      syncGlobal: 'Sync Global'
    },
    notifications2: {
      emailsSent: 'Emails enviados',
      openRate: 'Tasa de apertura',
      send: 'Enviar',
      historyTemplates: 'Historial & Templates',
      sendStats: 'Estadísticas de envío',
      resetStuck: 'Reiniciar bloqueados',
      resetting: 'Reiniciando...',
      noCampaignsStuck: 'Ninguna campaña bloqueada',
      allCampaignsValid: 'Todas las campañas son válidas',
      resetError: 'Error al reiniciar las campañas'
    },
    costAlerts: {
      roiCritical: 'ROI Crítico',
      roiCriticalMsg: 'Los costos de IA representan {{percent}}% del ingreso mensual',
      dailyCostHigh: 'Costo Diario Elevado',
      dailyCostHighMsg: 'Proyección mensual: €{{projected}} (costo diario: €{{daily}})',
      budgetExceeded: 'Presupuesto Excedido',
      budgetExceededMsg: 'Costo mensual actual: €{{current}} (límite: €{{limit}})',
      testAlertTitle: 'Test Alerta Costo',
      testAlertMsg: 'Notificación de prueba del sistema de alertas'
    },
    subscriptions: {
      monthly: 'Mensual',
      annual: 'Anual',
      trial: 'Prueba gratuita',
      premiumFree: 'Premium gratuito',
      expired: 'Expirado',
      free: 'Gratuito'
    }
  }
};